import { Link } from "react-router-dom";
import { MessageCircle, Phone, ShoppingBag, UtensilsCrossed } from "lucide-react";
import { SITE } from "../data/menu";

export const WhatsAppFloat = () => (
  <a
    href={SITE.whatsapp}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-[148px] right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.4)] transition-transform duration-300 hover:scale-110 md:bottom-24 md:right-8"
  >
    <MessageCircle size={26} fill="currentColor" />
  </a>
);

export const FloatingOrderButton = () => (
  <Link
    to="/order"
    data-testid="floating-order-button"
    className="fixed bottom-[84px] right-4 z-40 md:bottom-8 md:right-8"
  >
    <span className="absolute inset-0 animate-ping rounded-full bg-[#9B2C2C]/30" aria-hidden="true" />
    <span className="relative flex items-center gap-2 rounded-full bg-[#9B2C2C] px-5 py-3 text-sm font-bold text-white shadow-[0_14px_36px_rgba(122,29,40,0.5)] transition-transform duration-300 hover:scale-105">
      <ShoppingBag size={16} />
      Order Online
    </span>
  </Link>
);

export const MobileActionBar = () => (
  <div
    data-testid="mobile-action-bar"
    className="fixed bottom-0 left-0 z-50 flex w-full justify-around rounded-t-2xl bg-[#9B2C2C] py-3 text-white shadow-[0_-6px_24px_rgba(126,34,34,0.35)] md:hidden"
  >
    <a href={SITE.phoneHref} data-testid="mobile-bar-call" className="flex flex-col items-center gap-1 text-xs">
      <Phone size={20} /> Call
    </a>
    <a
      href={SITE.whatsapp}
      target="_blank"
      rel="noreferrer"
      data-testid="mobile-bar-whatsapp"
      className="flex flex-col items-center gap-1 text-xs"
    >
      <MessageCircle size={20} /> WhatsApp
    </a>
    <Link to="/menu" data-testid="mobile-bar-menu" className="flex flex-col items-center gap-1 text-xs">
      <UtensilsCrossed size={20} /> Menu
    </Link>
  </div>
);
